import React from "react";
import { Button, Icon, theme } from "uikit";

import { StyledRow, SuspenseLoader } from "..";

const SearchButtonWithLoader: React.FC<SearchButtonWithLoader.Props> = ({
	loading,
	onClick,
}) => (
	<StyledRow gap="10px" alignItems="center" minW="90px">
		<Button.Button
			variant="primary"
			focused={false}
			disabled={loading}
			icon={<Icon id="search" size={20} />}
			onClick={onClick}
		/>

		<StyledRow h="32px" alignItems="center">
			{loading && (
				<SuspenseLoader
					loader="6"
					dotSize={7}
					color={theme.colors.info}
				/>
			)}
		</StyledRow>
	</StyledRow>
);

declare namespace SearchButtonWithLoader {
	type Props = {
		loading: boolean;
		onClick: () => void;
	};
}

export default SearchButtonWithLoader;
